var _defs, _rect, _pattern, _rect2, _rect3, _text, _text2, _rect4, _line, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1, _text10, _rect12, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _rect13, _text19, _text20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlinko(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 600",
    width: 440,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#040d18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#061020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#030910"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ball-grad",
    cx: "35%",
    cy: "28%",
    r: "65%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff8c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ffc84c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8a5c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-g",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8fffee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a8fff8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "slot-16x",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1e0a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#130622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "slot-8x",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0e1535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#080e22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "slot-4x",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0e280e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#081808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "slot-2x",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#28200a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a1506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "slot-1x",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0e2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#081818"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "peg-glow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(143,255,238,0.6)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(143,255,238,0)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#bg)"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 0.6,
    fill: "rgba(143,255,238,0.05)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#dots)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 440,
    height: 3,
    fill: "url(#title-g)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 52,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 32,
    fontWeight: 900,
    fill: "url(#title-g)",
    letterSpacing: 6
  }, "PLINKO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 74,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 3
  }, "DROP THE BALL, WIN BIG")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 86,
    width: 384,
    height: 370,
    rx: 12,
    fill: "rgba(143,255,238,0.03)",
    stroke: "rgba(143,255,238,0.1)",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 86,
    x2: 220,
    y2: 108,
    stroke: "rgba(255,200,76,0.2)",
    strokeWidth: 1,
    strokeDasharray: "3,3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 110,
    r: 5,
    fill: "#8fffee",
    opacity: 0.65
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 110,
    r: 5,
    fill: "#8fffee",
    opacity: 0.65
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 110,
    r: 5,
    fill: "#8fffee",
    opacity: 0.65
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 148,
    r: 5,
    fill: "#8fffee",
    opacity: 0.62
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 148,
    r: 5,
    fill: "#8fffee",
    opacity: 0.62
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 148,
    r: 5,
    fill: "#8fffee",
    opacity: 0.62
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 148,
    r: 5,
    fill: "#8fffee",
    opacity: 0.62
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 186,
    r: 5,
    fill: "#8fffee",
    opacity: 0.58
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 186,
    r: 5,
    fill: "#8fffee",
    opacity: 0.58
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 186,
    r: 5,
    fill: "#8fffee",
    opacity: 0.58
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 186,
    r: 5,
    fill: "#8fffee",
    opacity: 0.58
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 186,
    r: 5,
    fill: "#8fffee",
    opacity: 0.58
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 224,
    r: 5,
    fill: "#8fffee",
    opacity: 0.55
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 224,
    r: 5,
    fill: "#8fffee",
    opacity: 0.55
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 224,
    r: 5,
    fill: "#8fffee",
    opacity: 0.55
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 224,
    r: 5,
    fill: "#8fffee",
    opacity: 0.55
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 224,
    r: 5,
    fill: "#8fffee",
    opacity: 0.55
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 224,
    r: 5,
    fill: "#8fffee",
    opacity: 0.55
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 262,
    r: 5,
    fill: "#8fffee",
    opacity: 0.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 262,
    r: 5,
    fill: "#8fffee",
    opacity: 0.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 262,
    r: 5,
    fill: "#8fffee",
    opacity: 0.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 262,
    r: 5,
    fill: "#8fffee",
    opacity: 0.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 262,
    r: 5,
    fill: "#8fffee",
    opacity: 0.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 262,
    r: 5,
    fill: "#8fffee",
    opacity: 0.5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 262,
    r: 5,
    fill: "#8fffee",
    opacity: 0.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 300,
    r: 5,
    fill: "#8fffee",
    opacity: 0.45
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 300,
    r: 5,
    fill: "#8fffee",
    opacity: 0.45
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 300,
    r: 5,
    fill: "#8fffee",
    opacity: 0.45
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 300,
    r: 5,
    fill: "#8fffee",
    opacity: 0.45
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 300,
    r: 5,
    fill: "#8fffee",
    opacity: 0.45
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 300,
    r: 5,
    fill: "#8fffee",
    opacity: 0.45
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 338,
    r: 5,
    fill: "#8fffee",
    opacity: 0.4
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 338,
    r: 5,
    fill: "#8fffee",
    opacity: 0.4
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 338,
    r: 5,
    fill: "#8fffee",
    opacity: 0.4
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 338,
    r: 5,
    fill: "#8fffee",
    opacity: 0.4
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 338,
    r: 5,
    fill: "#8fffee",
    opacity: 0.4
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 376,
    r: 5,
    fill: "#8fffee",
    opacity: 0.35
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 376,
    r: 5,
    fill: "#8fffee",
    opacity: 0.35
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 376,
    r: 5,
    fill: "#8fffee",
    opacity: 0.35
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 376,
    r: 5,
    fill: "#8fffee",
    opacity: 0.35
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    r: 10,
    fill: "url(#ball-grad)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "220;220;260;232;272;236;236;220",
    dur: "2.8s",
    keyTimes: "0;0.1;0.25;0.42;0.58;0.72;0.85;1",
    repeatCount: "indefinite",
    calcMode: "linear"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "100;110;148;186;224;262;300;338",
    dur: "2.8s",
    keyTimes: "0;0.1;0.25;0.42;0.58;0.72;0.85;1",
    repeatCount: "indefinite",
    calcMode: "linear"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;1;1;1;1;0.6",
    dur: "2.8s",
    keyTimes: "0;0.05;0.2;0.4;0.6;0.75;0.9;1",
    repeatCount: "indefinite"
  }))), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "rgba(255,255,255,0.4)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "217;217;257;229;269;233;233;217",
    dur: "2.8s",
    keyTimes: "0;0.1;0.25;0.42;0.58;0.72;0.85;1",
    repeatCount: "indefinite",
    calcMode: "linear"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "97;107;145;183;221;259;297;335",
    dur: "2.8s",
    keyTimes: "0;0.1;0.25;0.42;0.58;0.72;0.85;1",
    repeatCount: "indefinite",
    calcMode: "linear"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.4;0.4;0.4;0.4;0.4;0.4;0",
    dur: "2.8s",
    keyTimes: "0;0.05;0.2;0.4;0.6;0.75;0.9;1",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 456,
    width: 46,
    height: 60,
    rx: 4,
    fill: "url(#slot-16x)",
    stroke: "rgba(199,118,255,0.3)",
    strokeWidth: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 456,
    width: 42,
    height: 60,
    rx: 4,
    fill: "url(#slot-8x)",
    stroke: "rgba(82,111,255,0.25)",
    strokeWidth: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 456,
    width: 42,
    height: 60,
    rx: 4,
    fill: "url(#slot-4x)",
    stroke: "rgba(114,242,56,0.2)",
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 456,
    width: 42,
    height: 60,
    rx: 4,
    fill: "url(#slot-2x)",
    stroke: "rgba(255,200,76,0.18)",
    strokeWidth: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 450,
    width: 24,
    height: 70,
    rx: 4,
    fill: "url(#slot-1x)",
    stroke: "rgba(143,255,238,0.5)",
    strokeWidth: 1.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 456,
    width: 42,
    height: 60,
    rx: 4,
    fill: "url(#slot-2x)",
    stroke: "rgba(255,200,76,0.18)",
    strokeWidth: 1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 456,
    width: 42,
    height: 60,
    rx: 4,
    fill: "url(#slot-4x)",
    stroke: "rgba(114,242,56,0.2)",
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 456,
    width: 42,
    height: 60,
    rx: 4,
    fill: "url(#slot-8x)",
    stroke: "rgba(82,111,255,0.25)",
    strokeWidth: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 456,
    width: 46,
    height: 60,
    rx: 4,
    fill: "url(#slot-16x)",
    stroke: "rgba(199,118,255,0.3)",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 483,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "16")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 497,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 900,
    fill: "#c776ff"
  }, "\xD7")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 97,
    y: 483,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "8")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 97,
    y: 497,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 900,
    fill: "#526fff"
  }, "\xD7")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 141,
    y: 483,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "4")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 141,
    y: 497,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 900,
    fill: "#72F238"
  }, "\xD7")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 483,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "2")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 497,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 900,
    fill: "#ffc84c"
  }, "\xD7")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 478,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "1")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 495,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 14,
    fontWeight: 900,
    fill: "#8fffee"
  }, "\xD7")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 450,
    width: 24,
    height: 70,
    rx: 4,
    fill: "none",
    stroke: "rgba(143,255,238,0.8)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 483,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "2")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 497,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 900,
    fill: "#ffc84c"
  }, "\xD7")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 299,
    y: 483,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "4")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 299,
    y: 497,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 900,
    fill: "#72F238"
  }, "\xD7")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 343,
    y: 483,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "8")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 343,
    y: 497,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 900,
    fill: "#526fff"
  }, "\xD7")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 389,
    y: 483,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 700,
    fill: "rgba(255,255,255,0.4)"
  }, "16")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 389,
    y: 497,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 900,
    fill: "#c776ff"
  }, "\xD7")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 530,
    width: 384,
    height: 44,
    rx: 10,
    fill: "rgba(0,0,0,0.4)"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 548,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 10,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 2
  }, "RISK: MEDIUM \xB7 16 ROWS")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 566,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fill: "rgba(255,255,255,0.22)",
    letterSpacing: 2
  }, "NEXTGEN ORIGINALS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlinko);
export default __webpack_public_path__ + "static/media/plinko.913335a1faa48ec46cde820e62a7b41f.svg";
export { ForwardRef as ReactComponent };